export default "__VITE_ASSET__B7nEsD7C__"